import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8688sz59tv: FaireBrandEntity = {
  token: "b_8688sz59tv",
  type: "brand",
  name: "Showcase",
  avatarUrl: "https://cdn.faire.com/fastly/7bb2729577d1f0ccc2611b96fbc2d4d82d93687542356c51d2dd12c30b85b3d7.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/d43962cbe855628f49ad053b74a95cfbe8d4714ca99f1e1442b586364aa59e7a.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/7bb2729577d1f0ccc2611b96fbc2d4d82d93687542356c51d2dd12c30b85b3d7.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/d43962cbe855628f49ad053b74a95cfbe8d4714ca99f1e1442b586364aa59e7a.jpeg",
  location: "Batavia, NY, USA",
  minimumOrderDollars: 149,
  rating: 4.8,
  reviewCount: 1129,
  isTopShop: true,
  isInsider: false,
  description: "At Showcase, we don’t follow trends — we create them.\n\nFor over 30 years, we’ve operated 150+ permanent retail stores across North America, giving us real-time insight into what customers actually buy. As a retailer first, we know what works — not just what looks good online.\n\nOur team uses AI, social media trend tracking, and in-store data to identify emerging products early — often months before the market. We then move fast to design and launch exclusive, high-performing products.\n\nWe were among the first to launch on Faire some of today’s biggest viral categories, including:\n• Dubai Chocolate\n• Mystery Dumplings / Bao Buns\n• Nommi Collectibles\n• Mystery Crunchers\n• Wax Candy\n• Taba Squishies & Sensory Fidgets\n\nEvery product is retail-tested, UPC-coded, compliant, and packaged for strong shelf presence and impulse sales.\n\nOur assortment evolves constantly to keep you stocked with what’s trending now — not yesterday.\n\nPartner with Showcase and give your store a proven, viral edge.",
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:56:44.723Z",
    importedBy: "entity-db-cli"
  }
};
